
export const getGoogleDriveImageUrl = (url: string): string => {
    if (!url) return '';

    // إذا كان الرابط ليس من Google Drive، نعيده كما هو
    if (!isGoogleDriveUrl(url)) return url;

    // استخراج معرف الملف
    const fileId = extractGoogleDriveFileId(url);
    if (!fileId) return url;

    // إذا كان الرابط بصيغة /uc?export=view
    if (url.includes('uc?export=view')) {
        return url;
    }

    // تحويل الرابط إلى صيغة المعاينة المباشرة
    return `https://drive.google.com/thumbnail?id=${fileId}`;
};

/**
 * استخراج معرف الملف من رابط Google Drive
 * @param url رابط Google Drive
 * @returns معرف الملف
 */
export const extractGoogleDriveFileId = (url: string): string => {
    if (!url) return '';

    // محاولة استخراج المعرف من أنماط مختلفة من روابط Drive
    const patterns = [
        /\/file\/d\/([-\w]{25,})/,        // رابط مشاركة الملف
        /id=([-\w]{25,})/,                // رابط معاينة
        /[-\w]{25,}/                      // المعرف المباشر
    ];

    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) return match[1];
    }

    return '';
};

/**
 * التحقق مما إذا كان الرابط هو رابط Google Drive
 * @param url الرابط المراد فحصه
 * @returns true إذا كان رابط Drive
 */
export const isGoogleDriveUrl = (url: string): boolean => {
    if (!url) return false;
    return url.includes('drive.google.com') || url.includes('docs.google.com');
}; 